import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=628dffc4&scoped=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=628dffc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628dffc4",
  null
  
)

export default component.exports